<template>
    <v-main>
      <v-layout justify-center class="ma-2">
        <v-card class="px-4 rounded-xl" width="1200">
          <v-card-title>
            Cadastrar Médico de Unidade
          </v-card-title>
          <v-divider class="mb-2" />
          <v-form v-model="valid" ref="form">
            <v-text-field label="Nome completo" v-model="nome" :rules="[v => !!v || 'Campo obrigatório']" required></v-text-field>
            <v-text-field label="Username" v-model="username" :rules="usernameRules" required></v-text-field>

            <v-text-field v-model="senha" autocomplete="new-password" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="Senha" counter @click:append="show1 = !show1"></v-text-field>

            <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Você deve concordar para cadastrar']" required></v-checkbox>

            <v-alert :value="erroLogin" color="error" icon="warning" outlined>
              Usuário já existente !!
            </v-alert>

            <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
              Atendente cadastrado com sucesso !!
            </v-alert>
            <v-card-actions>
              <v-spacer />
              <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">cadastrar</v-btn>
              <v-btn rounded outlined to='/listaMedicosUnidade'>
                <v-icon left>keyboard_backspace</v-icon>
                voltar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-layout>
    </v-main>
    </template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import medicoService from '../../../services/medico.service'

export default {
  name: 'cadastrarMedicosUnidade',
  data () {
    return {
      show1: false,
      tipo: 3,
      valid: false,
      erroLogin: false,
      sucessoLogin: false,
      listaLocais: [],
      isEditing: true,
      senha: '',
      username: null,
      nome: '',
      idLocalEscolhido: '',
      respostaServidor: '',
      idUnidadeEscolhida: '',
      listaUnidades: [],
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 5 || 'Senha deve ter mais de 6 caracteres'
      ],
      nameRules: [
        (v) => !!v || 'Nome obrigatório',
        (v) => v && v.length > 7 || 'Este campo deve ter mais de 7 caracteres '
      ],
      usernameRules: [
        (v) => !!v || 'Username obrigatório',
        (v) => v && v.length > 7 || 'Username deve ter mais de 7 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: true

    }
  },
  components: {
    // HelloWorld
  },

  methods: {

    retornarPossiveisRecepcionista () { // get
      this.listaRecepcionistas = []
      administradorUnidadeService.administradorUnidade
        .retornarPossiveisRecepcionistas()
        .then(rsp => {
          console.log('rsp retornarPossiveisRecepcionista:', rsp.data)
          this.listaPossiveisRecepcionistas = rsp.data
          this.listaPossiveisRecepcionistas.forEach(elementPossivel => {
            if (!this.listaRecepcionistasCadastradas.find(elementCadastrado =>
              elementCadastrado.username == elementPossivel.username
            )) {
              this.listaRecepcionistas.push(elementPossivel)
            }
          })
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    clear () {
      this.$refs.form.reset()
      this.errorCadastrar = false
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.erroLogin = false
        this.sucessoLogin = false
        console.log('form valido')

        // medicoService.medico.cadastrarMedico(this.user.idLocal, this.username, this.senha, this.tipo, this.nome, null)
        // .then(rsp => {
        //     console.log('rsp oi:')
        //     console.log(rsp.data)
        //     if (rsp.data == 'usernameExistente') {
        //     this.erroLogin = true
        //     }
        //     if (rsp.data == true) {
        //     this.sucessoLogin = true
        //     this.clear()
        //     }

        //     // console.log(this.listaChamadas);
        //     // this.servicoTeste = rsp.data
        // })
        // .catch(err => {
        //     // handle your error here
        //     console.log(err)
        // })
      }
    },

    limpar () {
      this.senha = ''
      this.idUnidadeEscolhida = ''
    }

  },
  created () {
    console.log('created...')
  },
  watch: {
    sucessCadastrar: function (val) {
      setTimeout(() => {
        this.$router.push('/listaMedicosUnidade')
      }, 3000)
    },
    errorCadastrar: function (val) {
      setTimeout(() => {
        this.errorCadastrar = false
      }, 3000)
    }
  },
  mounted () {
    console.log('em mounted MEDICOSSSSSSSSSSSSSSS')
    this.limpar()
    this.user = this.$store.getters.usuario
    // if (!this.$route.params.listaRecepcionistasCadastradas) {
    //   this.$router.push('/listaMedicosUnidade')
    //   return
    // }
    // console.log('parametro total recep', this.$route.params.listaRecepcionistasCadastradas)
    // this.listaRecepcionistasCadastradas = this.$route.params.listaRecepcionistasCadastradas
    // this.retornarPossiveisRecepcionista()
  }
}
</script>
